<template>
  <header class="wrapper">
    <div
      class="header container"
      :class="{ 'header_search-expanded': isSearchExpanded }"
    >
      <router-link class="logo" to="/">
        <img
          class="logo__img logo__img_desktop"
          :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-${theme}.svg`)"
        />
        <img
          class="logo__img logo__img_mobile"
          :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-mobile-${theme}.svg`)"
        />
      </router-link>

      <search class="header__search" />

      <theme-switch class="header__theme-switch" />

      <links class="header__links" />

      <device class="header__device" />
    </div>
    <navigation />
  </header>
</template>

<script>
import { mapState } from 'vuex';
import Device from './Device';
import Search from './Search';
import Links from './Links';
import Navigation from './Navigation';
import ThemeSwitch from './ThemeSwitch.vue';

export default {
  components: {
    Device, Search, Links, Navigation, ThemeSwitch,
  },
  computed: {
    ...mapState(['theme']),
    isSearchExpanded() {
      return this.$store.getters.isSearchExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.wrapper {
  position: relative;
}

.header {
  padding: 25px 0;
  display: flex;
  align-items: center;

  @include notebook {
    padding: 10px 0;
  }

  &_search-expanded {
    @include notebook {
      .header__search {
        margin-left: 10px;
      }

      .header__device,
      .header__theme-switch {
        display: none;
      }
    }
  }

  &__search {
    margin: 0 15px 0 20px;

    @include notebook {
      order: 4;
      margin-left: auto;
      margin-right: 6px;
    }
  }

  &__theme-switch {
    @include notebook {
      order: 3;
    }
  }

  &__links {
    @include notebook {
      order: 5;
      margin-right: 10px;
    }
  }

  &__device {
    @include notebook {
      order: 2;
      margin-left: 14px;
      margin-right: 14px;
      display: block;
      min-width: 0;
      position: relative;
      height: 41px;
    }
  }
}

.logo {
  max-width: 92px;
  height: 37px;

  @include notebook {
    order: 1;
    max-width: 49px;
    height: 41px;
    flex: 0 0 49px;
  }

  &__img {
    max-width: 100%;
    height: 100%;

    &_mobile {
      display: none;

      @include notebook {
        display: block;
      }
    }

    &_desktop {
      @include notebook {
        display: none;
      }
    }
  }
}
</style>
